type Listener = (online: boolean) => void;

/** Surveillance de la connectivité navigateur (mode distant / activation). */
export class NetworkStatusService {
  private static listeners = new Set<Listener>();
  private static wired = false;

  static isBrowserOnline(): boolean {
    if (typeof navigator === 'undefined') return true;
    return navigator.onLine;
  }

  static subscribe(listener: Listener): () => void {
    NetworkStatusService.ensureWired();
    NetworkStatusService.listeners.add(listener);
    listener(NetworkStatusService.isBrowserOnline());
    return () => NetworkStatusService.listeners.delete(listener);
  }

  private static ensureWired(): void {
    if (NetworkStatusService.wired || typeof window === 'undefined') return;
    NetworkStatusService.wired = true;
    window.addEventListener('online', () => NetworkStatusService.notify(true));
    window.addEventListener('offline', () => NetworkStatusService.notify(false));
  }

  private static notify(online: boolean): void {
    for (const listener of NetworkStatusService.listeners) listener(online);
  }
}

export function formatNetworkStatusLabel(online: boolean): string {
  // Ne jamais afficher « Hors connexion » si le navigateur est online.
  return online ? 'Réseau disponible' : 'Hors connexion';
}
